export const hiddenDrawerRoutes = [
    "/",
    "/messages",
    "/not-found",
    "/privacy-policy",
    "/creator-agreement",
    "/enterprise-addendum",
    "/terms-of-use",
    "/initial-setting",
    "/welcome",
    "/logout",
    "/select-enterprise",
    "/success",
    "/payment-cancel",
    "/signup-splash",
    "/signup",
    "/login",
];
